/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {DynamicDialogContent as ɵa} from './dynamicdialogcontent';